import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './index.module.scss';

const CompanyLogo = ({ name, src, big, small, ariaHidden }) => (
  <div
    className={classNames(styles.component, {
      [styles['component--small']]: small,
      [styles['component--big']]: big,
    })}
  >
    <img src={src} alt={name} aria-hidden={ariaHidden ? 'true' : 'false'} />
  </div>
);

CompanyLogo.propTypes = {
  small: PropTypes.bool,
  big: PropTypes.bool,
};

export default CompanyLogo;
